export default __webpack_public_path__ + "media/images/features/jtb/furu-po-758811cae7b038b8364b5a86a7815696.png";